import {
  ChatCallbacks,
  ChatTranslations
} from "@genexus/chameleon-controls-library";
import { ChatMessageFile } from "@genexus/chameleon-controls-library/dist/types/components/chat/types";

import { ASSISTANT_RESPONSE_MARKDOWN } from "./models";

import { ASSISTANT_NAME } from "./models";
import { MercuryChatMessageMetadata } from "@genexus/mercury";

const PROCESSING_PLACEHOLDER = "{{ASSISTANT_NAME}}";

const sendChatMessages = (chatRef: HTMLChChatElement) => () => {
  chatRef.waitingResponse = true;

  chatRef.addNewMessage({
    id: `${new Date().getTime()}`,
    role: "assistant",
    content: "Analyzing",
    status: "waiting",
    metadata: {
      agentName: ASSISTANT_NAME,
      time: "14:25"
    } satisfies MercuryChatMessageMetadata
  });

  setTimeout(() => {
    chatRef.updateLastMessage(
      {
        role: "assistant",
        content: "Processing with Chat with LLMs",
        status: "waiting",
        metadata: {
          agentName: ASSISTANT_NAME,
          time: "14:25"
        } satisfies MercuryChatMessageMetadata
      },
      "replace"
    );

    setTimeout(() => {
      dummyStreaming(chatRef, 20, ASSISTANT_RESPONSE_MARKDOWN, "replace");
    }, 2000);
  }, 2000);
};

const stopResponseAnswer = (): Promise<void> => {
  console.log("stop generating answer");
  return new Promise<void>(resolve => {
    // Lógica asincrónica aquí si es necesario
    resolve();
  });
};

export const chatCallbacksWithChatRef = (
  chChatRef: HTMLChChatElement
): ChatCallbacks => {
  return {
    sendChatMessages: sendChatMessages(chChatRef),
    uploadFile: (file: File) =>
      new Promise<ChatMessageFile>(() => {
        console.log("file", file);

        return Promise.resolve({
          url: "Error",
          mimeType: "application/javascript"
        } satisfies ChatMessageFile);
      }),
    stopResponse: stopResponseAnswer
  };
};

function dummyStreaming(
  chatRef: HTMLChChatElement,
  counter: number,
  stringToDisplay: string,
  mode: "concat" | "replace"
) {
  setTimeout(
    () => {
      const streamingCompleted = counter >= stringToDisplay.length;

      chatRef.updateLastMessage(
        {
          role: "assistant",
          content: stringToDisplay.substring(counter - 20, counter),

          // {
          //   message: stringToDisplay.substring(counter - 20, counter),
          //   files: streamingCompleted
          //     ? [
          //         {
          //           url: "https://next.genexus.ai",
          //           caption: "Mars Exploration Contract"
          //         },
          //         {
          //           url: "https://gx-chameleon.netlify.app",
          //           caption: "Venus Exploration Contract"
          //         }
          //       ]
          //     : undefined
          // },
          status: streamingCompleted ? "complete" : "streaming",
          metadata: {
            agentName: ASSISTANT_NAME,
            time: "14:25"
          } satisfies MercuryChatMessageMetadata
        },
        mode
      );

      if (!streamingCompleted) {
        dummyStreaming(chatRef, counter + 20, stringToDisplay, "concat");
      } else {
        chatRef.waitingResponse = false;
      }
    },
    counter % 200 === 0 ? 50 : 40
  );
}

export const chatTranslations: ChatTranslations = {
  accessibleName: {
    clearChat: "Clear chat",
    copyMessageContent: "Copy message",
    downloadCodeButton: "Download code",
    sendButton: "Send",
    sendInput: "Message",
    stopResponseButton: "Stop generating answer"
  },
  placeholder: {
    sendInput: "Ask me a question..."
  },
  text: {
    copyCodeButton: "Copy code",
    copyMessageContent: "Copy message content",
    downloadCodeButton: "Download code",
    processing: `Processing with ${PROCESSING_PLACEHOLDER}`,
    sourceFiles: "Source files:",
    stopResponseButton: ""
  }
};
